export const STUDENT_ROLE = 0;
export const INSTRUCTOR_ROLE = 1;
export const CAMPUS_VOLUNTEER_ROLE = 2;
export const ONLINE_VOLUNTEER_ROLE = 3;
export const STAFF_ROLE = 4;
